/** @type {{ storeName: string }} */
const props = document.querySelector("#recover-form").dataset;

const ENDPOINT = "https://accounts.crankyhealth.dev/recover";
const STORE = { "The Man Shake": "tms", "The Lady Shake": "tls" }[props.storeName];

const originalSubmit = HTMLFormElement.prototype.submit;
HTMLFormElement.prototype.submit = function (...args) {
  // Dispatch a custom event you can listen for
  const event = new Event("programmatic-submit", { bubbles: true, cancelable: true });
  const canceled = !this.dispatchEvent(event);

  if (!canceled) {
    return originalSubmit.apply(this, args); // proceed if not canceled
  }
};

const handler = async (event) => {
  event.preventDefault();

  const formData = new FormData(recoverForm);
  const email = formData.get("email");

  // Encrypt email
  const encryptedEmail = await encryptEmail(email);

  try {
    await fetch(ENDPOINT, {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ store: STORE, email: encryptedEmail }),
    }).then((response) => (response.ok ? response : Promise.reject(response)));

    recoverForm.removeEventListener("programmatic-submit", handler);
    recoverForm.requestSubmit();
  } catch (_error) {
    alert("Unable to recover password. Please contact support.");
    // location.reload();
  }
};

/** @type {HTMLFormElement} */
const recoverForm = document.getElementById("recover-customer-password-form");
recoverForm.addEventListener("programmatic-submit", handler);

/** Crypto */

const PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA7VvMLzaoKEbV5O2r1taR
O0xc3n2giUwcdfgGpv7KSpUXvYlyosmwotAH8x5h1IcqSXcMRNUWH9JJhNCEdc+b
bKRLU/aLEj58vHuNL6sQggoeWVhwzi9u4mcdVJ2iiXlBf7A+A82mb3V+9xgU36m2
G4GaDirJtNd1YFhaMftb2PGfb7HYS+iZbotQNKN11ev6XSSuyBbuWOoDpNCL0zyc
p8s3/1PMTPfY3etz5f19iS5xxIBsarFr0/V4bDIL8HwMlkR/XaLxDhgJ+FN6soLA
cAgJXsla8ne7wA10Bg0lg7B6ltgAdMEy4edizP71SMdphjNGU793/lt7+9WHbUC0
kwIDAQAB
-----END PUBLIC KEY-----`;

function pemToBinary(pem) {
  const b64 = pem
    .replace(/-----BEGIN PUBLIC KEY-----/, "")
    .replace(/-----END PUBLIC KEY-----/, "")
    .replace(/\s+/g, "");
  return Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
}

async function importPublicKey(pem) {
  const binary = pemToBinary(pem);
  return crypto.subtle.importKey("spki", binary.buffer, { name: "RSA-OAEP", hash: "SHA-256" }, true, ["encrypt"]);
}

export async function encryptEmail(email) {
  const publicKey = await importPublicKey(PUBLIC_KEY);
  const encodedEmail = new TextEncoder().encode(email);

  const encryptedBuffer = await crypto.subtle.encrypt({ name: "RSA-OAEP" }, publicKey, encodedEmail);

  // Convert encrypted bytes to Base64 for safe transmission
  return btoa(String.fromCharCode(...new Uint8Array(encryptedBuffer)));
}
